import { getHttpClient } from "@/core/api";

export async function getAllCarriers() {
  const response = await getHttpClient().get("v2/organizations/carriers");
  return response.data;
}

export async function getCarriersWithTransports() {
  const response = await getHttpClient().get("v2/organizations/carriers/with-transport");
  return response.data;
}
